import he from 'he';

export const decodeIfString = (value) => (typeof value === 'string') ? he.decode(value) : value;


// WEBPACK FOOTER //
// ./src/services/content-rendering.js